import { create } from "zustand";
import { combine } from "zustand/middleware";

export type RiskValues = {
  min: number;
  max: number;
};

type ApplicationState = {
  selectedCompany: string;
  selectedReturnPeriod: string;
  selectedRisk: RiskValues;
  savingsValue: number;
  tableAutoScroll: boolean;
};

const initialState: ApplicationState = {
  selectedCompany: "",
  selectedReturnPeriod: "",
  selectedRisk: {
    min: 1,
    max: 7,
  },
  savingsValue: 10000,
  tableAutoScroll: false,
};

const useApplicationStore = create(
  combine(initialState, (set) => ({
    setSelectedCompany: (value: string) =>
      set(() => ({ selectedCompany: value })),
    setSelectedReturnPeriod: (value: string) =>
      set(() => ({ selectedReturnPeriod: value })),
    setSelectedRisk: (value: RiskValues) =>
      set(() => ({ selectedRisk: value })),
    setSavingsValue: (value: number) => set(() => ({ savingsValue: value })),
    resetState: () => set(initialState),
    updateAutoScroll: (value: boolean) =>
      set(() => ({ tableAutoScroll: value })),
  })),
);

export default useApplicationStore;
